module.exports = __webpack_public_path__ + "img/logo-17.890f9eb3.png";